module.exports = __webpack_public_path__ + "a8c79033000a28b66f4451abcefdb51d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/games/Dawn-of-War-II.jpg
// module id = 393
// module chunks = 0